import React from 'react';
import { Translate } from 'core/translate';

const PackagePricing = ({ option, cashAllowanceSelected, className }) => {
  const {
    discountedPriceTotal,
    displayedMsrp,
    rpocashValue,
    rpoCash,
    appliedPackageCash
  } = option;

  const priceLine = (
    <div
      className={`package-pricing__price ${
        discountedPriceTotal ? 'package-pricing__price--strike' : ''
      }`}>
      {displayedMsrp}
    </div>
  );
  const discountPriceLine = discountedPriceTotal ? (
    <div>
      <span className="package-pricing__price-label">
        <Translate value="discounted.price" />
      </span>{' '}
      <span className="package-pricing__price">{discountedPriceTotal}</span>
    </div>
  ) : null;
  const cashLine = rpocashValue ? (
    <div
      className={`package-pricing__cash-allowance ${
        !appliedPackageCash && cashAllowanceSelected
          ? 'package-pricing__cash-allowance--strike'
          : ''
      }`}>
      <Translate value="cash.allowance.includes" cash={rpoCash} />
    </div>
  ) : null;

  return (
    <div className={`package-pricing ${className || ''}`}>
      {priceLine}
      {discountPriceLine}
      {cashLine}
    </div>
  );
};

export default PackagePricing;
